import styled from 'styled-components';
import { rgba } from 'polished';

import { cFFFFFF } from '#/colors';

import { useDepositFormView } from '#/features/deposit/form-context';

export default function AvailableFunds() {
  const depositFormView = useDepositFormView();

  return (
    <Container>
      <span>Available on L1</span>{' '}
      <span>
        {depositFormView.balance} {depositFormView.asset.symbol}
      </span>
    </Container>
  );
}

const Container = styled.div`
  color: ${rgba(cFFFFFF, 0.7)};
  display: flex;
  font-size: 11px;
  font-weight: 500;
  width: 100%;
  justify-content: space-between;
  padding: 0 14px;
`;
